import React from 'react'
import {Trans, withNamespaces} from 'react-i18next'
import {graphql, withApollo} from 'react-apollo'
import {currencies} from '@bdswiss/common-enums'
import Button from '@material-ui/core/Button'
import {get, find, isEmpty, reject, some, includes, flowRight as compose, floor} from 'lodash'
import Grid from '@material-ui/core/Grid'
import Hidden from '@material-ui/core/Hidden'
import withStyles from '@material-ui/core/styles/withStyles'
import {Loading} from '../../Common/Loading'
import AmountInput from '../../Common/AmountInput'
import messages from '../../../assets/messages'
import {TRANSFER_FUNDS_MUTATION, CREATE_INTERNAL_TRANSFER} from '../../../graphql/mutations'
import {
  PAYMENTS_ACCOUNTS_QUERY,
  IB_CLIENTS_QUERY,
  FIND_CLIENT_QUERY,
  CLIENT_DATA_QUERY,
  SPOA_AUTHORIZATION_QUERY,
  RELATED_IB_QUERY,
} from '../../../graphql/queries'
import {
  isDemoAccount,
  isMAMMasterAccount,
  isAffiliatesAccount,
  isPAMMFundManagerAccount,
  isForexBdxAccount,
  isIntroducingBrokerAccount,
  isEmptySubscriptionAccount,
  isBitnukAccount,
  isPammManagerTradeAccount,
  isPammManagerAccount,
  isBrokereePerformanceFeeAccount,
} from '../../../common/utils/accounts'
import AppContext from '../../Common/contexts/AppContext'
import LoadingButton from '../../Common/LoadingButton'
import PageSubTitle from '../../Common/PageSubTitle'
import Images from '../../Common/Images'
import AccountSearchSelect from '../../Common/AccountSearchSelect'
import Typography from '@material-ui/core/Typography'
import TextField from '@material-ui/core/TextField'
import SearchOutlined from '@material-ui/icons/SearchOutlined'
import FormHelperText from '@material-ui/core/FormHelperText'
import classNames from 'classnames'
import {config} from '../../../config'
import {InnerAppContext} from '../../../common/types'
import {WithdrawalBlockedPopup} from '../../WithdrawalBlockedPopup'
import NotificationBar from '../../Common/NotificationBar'

const styles = (theme) => ({
  formControl: {
    margin: theme.spacing(1),
    display: 'flex',
  },
  errors: {
    color: theme.palette.error.main,
    marginLeft: 0,
    paddingLeft: 0,
    listStyle: 'none',
  },
  transferAmount: {
    paddingTop: 30,
    textAlign: 'center' as const,
  },
  transferIcon: {
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'center',
    transform: `rotate(${theme.direction === 'rtl' ? '180deg' : 0})`,
  },
  root: {
    flexGrow: 1,
  },
  blueAvatar: {
    margin: 10,
    color: theme.palette.primary.main,
    backgroundColor: theme.palette.lightblue.color,
    [theme.breakpoints.down('xs')]: {
      margin: '0 10px 0 0',
      height: 35,
      width: 35,
      lineHeight: 37,
    },
  },
  subtitle: {
    color: theme.palette.grey.color,
    fontWeight: 300,
  },
  tool: {
    [theme.breakpoints.down('xs')]: {
      position: 'absolute' as const,
      right: 0,
      top: -15,
    },
  },
  toolOuter: {
    [theme.breakpoints.down('xs')]: {
      position: 'relative' as const,
    },
  },
  affiliateDetails: {
    marginTop: 15,
    marginBottom: 0,
  },
  searchDiv: {
    position: 'relative' as const,
    [theme.breakpoints.down('xs')]: {
      marginTop: 20,
    },
  },
  searchIcon: {
    bottom: 10,
    position: 'absolute' as const,
    cursor: 'pointer',
  },
  error: {
    color: theme.palette.error.main,
    display: 'inline-block',
    verticalAlign: 'bottom',
    margin: '13px 13px 13px 0',
  },
  errText: {
    color: theme.palette.error.main,
  },
  succText: {
    color: theme.palette.green.color,
  },
  clientCheckMsg: {
    textAlign: 'center' as const,
    marginTop: 10,
  },
  textBlue: {
    color: theme.palette.primary.main,
  },
  toGrid: {
    [theme.breakpoints.down('xs')]: {
      marginTop: 20,
    },
  },
  amountButton: {
    backgroundColor: theme.palette.extralightgreyBackground.color,
    textTransform: 'none' as const,
  },
})

class Transfer extends React.Component<any, any> {
  static contextType = AppContext
  context!: InnerAppContext
  state = {
    withdrawalBlockedPopupOpen: false,
    transferFrom: '',
    transferFromAccount: '',
    transferFromCurrency: '',
    accountsWithdrawal: [],
    transferTo: '',
    transferToAccount: '',
    transferAmount: null,
    accountsDeposit: [],
    errors: [],
    errorsFields: {},
    errorsFieldsAffiliate: {},
    showNotification: false,
    failureMessage: '',
    submitButtonDisabled: false,
    affiliateClientId: '',
    affiliateAccountId: '',
    affiliateEmail: '',
    affiliateError: '',
    affiliateSuccess: {},
    clientCheckMsg: false,
    disabledTransfer: false,
  } as any

  listItemData = (a) => ({
    id: a.remoteId,
    key: a.remoteId,
    disabled: false,
    ...a,
  })

  validAccountsWithdrawal = (accounts) =>
    accounts
      .filter(
        (a) =>
          !isDemoAccount(a) &&
          !isMAMMasterAccount(a) &&
          !isPAMMFundManagerAccount(a) &&
          !isPammManagerTradeAccount(a) &&
          !isForexBdxAccount(a) &&
          !isEmptySubscriptionAccount(a) &&
          (!isPammManagerAccount(a)) &&
          ((this.props.pathSend && isAffiliatesAccount(a)) || !this.props.pathSend) &&
          ((this.props.pathSpoa && !isIntroducingBrokerAccount(a)) || !this.props.pathSpoa) &&
          ((this.props.pathIb && isIntroducingBrokerAccount(a) && !get(a, 'ignoreIbTransfers')) ||
            !this.props.pathIb),
      )
      .map(this.listItemData)
      .map((a) => ({...a, disabled: a.balance <= 0}))

  validAccountsDeposit = (accounts) =>
    accounts
      .filter(
        (a) =>
          !isDemoAccount(a) &&
          !isMAMMasterAccount(a) &&
          !isAffiliatesAccount(a) &&
          !isPAMMFundManagerAccount(a) &&
          !isPammManagerTradeAccount(a) &&
          !isForexBdxAccount(a) &&
          !isEmptySubscriptionAccount(a) &&
          ((this.props.pathSpoa && !isBitnukAccount(a)) || !this.props.pathSpoa) &&
          ((this.props.pathIb && isIntroducingBrokerAccount(a)) ||
            !isIntroducingBrokerAccount(a)) &&
          !a.isViewOnly &&
          !isBrokereePerformanceFeeAccount(a),
      )
      .map(this.listItemData)

  handleClientToChange(prop, value) {
    const clients = this.props.pathIb
      ? this.props.relatedIbs
      : !isEmpty(this.props.ibClients)
      ? this.props.ibClients
      : this.props.clientsIb
    if (value !== this.state[prop]) {
      const client = find(clients, (o) => o.id === value)
      this.setState((state) => ({
        [prop]: value,
        accountsDeposit: get(client, 'accounts', []),
        transferToAccount: (this.props.pathIb && get(client, 'accountId')) || '',
        errorsFields: {...state.errorsFields, [prop]: !value},
      }))
    }
  }

  handleClientFromChange(prop, value) {
    const clients = !isEmpty(this.props.ibClients) ? this.props.ibClients : this.props.clientsIb
    if (value !== this.state[prop]) {
      const client = find(clients, (o) => o.id === value)
      this.setState((state) => ({
        [prop]: value,
        accountsWithdrawal: get(client, 'accounts', []),
        transferFromAccount: '',
        errorsFields: {...state.errorsFields, [prop]: !value},
      }))
    }
  }

  handleChange(name, value) {
    this.setState((state) => ({
      [name]: value,
      errorsFields: {
        ...state.errorsFields,
        [name]: !value,
      },
    }))
  }

  isValid() {
    const {
      t,
      ibClients,
      clientsIb,
      match: {params: urlParams},
      pathSend,
      pathSpoa,
      pathIb,
    } = this.props
    const {
      transferAmount,
      transferFromAccount,
      transferToAccount,
      transferFrom,
      transferTo,
      affiliateSuccess,
    } = this.state
    const errors: any = []
    const errorsFields = {}
    const selectedAccountId = Number(get(urlParams, 'accountId') || '')
    const forceSelectedAccount = transferFrom === '' && selectedAccountId

    if (pathSend) this.findClient(true)
    // no transfer accounts
    if (transferFromAccount === '' && transferToAccount === '') {
      errors.push(t(messages.noAccountsSelected.i18nKey, messages.noAccountsSelected.defaults))
    } else {
      // same transfer accounts
      if (
        transferFromAccount === transferToAccount &&
        !(transferFromAccount === '' && transferToAccount === '')
      ) {
        errors.push(
          t(messages.noSameTransferAccounts.i18nKey, messages.noSameTransferAccounts.defaults),
        )
      }
    }

    const fields: any = {transferAmount, transferFromAccount, transferToAccount}
    if (
      ((!isEmpty(ibClients) && ibClients.length > 0) ||
        (!isEmpty(clientsIb) && clientsIb.length > 0)) &&
      pathSpoa
    ) {
      fields.transferTo = transferTo
    }

    if (pathIb && transferTo === '') {
      errorsFields['transferTo'] = true
    }

    for (const field of Object.keys(fields)) {
      if (field === 'transferToAccount' && !isEmpty(affiliateSuccess)) {
        continue
      }
      if (!(field === 'transferFromAccount' && forceSelectedAccount))
        errorsFields[field] = !fields[field] || fields[field] === 0
    }

    if (transferAmount <= 0) errorsFields['transferAmount'] = true

    this.setState({errors})

    if (some(errorsFields) || errors.length !== 0) {
      this.setState({errorsFields})
      return
    }
    this.handleSubmit()
  }

  handleSubmit() {
    const {transferFromAccount, transferToAccount, transferAmount, affiliateSuccess, transferTo} =
      this.state
    const {
      history,
      match: {params: urlParams},
    } = this.props
    this.setState({submitButtonDisabled: true})
    const variables = {
      fromAccountId: transferFromAccount || Number(get(urlParams, 'accountId')),
      toAccountId: transferToAccount || affiliateSuccess.accountId || transferTo,
      amount: transferAmount,
    }
    if (!isEmpty(affiliateSuccess)) {
      this.props
        .fundInternalTransferMutaion({variables})
        .then((success) => {
          this.setState({submitButtonDisabled: false})
          this.context.showNotification({
            type: 'payment',
            status: 'success',
            content: <Trans {...messages.transferSuccess} />,
            buttonMessage: <Trans {...messages.continue} />,
          })
        })
        .then(() => history.push('/accounts'))
        .catch((err) => {
          this.setState({submitButtonDisabled: false})
          this.context.showNotification({
            type: 'payment',
            status: 'failure',
            content: get(err, 'graphQLErrors[0].message') || err.message,
            buttonMessage: <Trans {...messages.cancel} />,
          })
        })
    } else {
      this.props
        .fundTransferMutation({variables})
        .then(() => {
          this.setState({submitButtonDisabled: false})
          this.context.showNotification({
            type: 'payment',
            status: 'success',
            content: <Trans {...messages.transferSuccess} />,
            buttonMessage: <Trans {...messages.continue} />,
          })
        })
        .then(() => history.push('/accounts'))
        .catch((err) => {
          this.setState({submitButtonDisabled: false})
          this.context.showNotification({
            type: 'payment',
            status: 'failure',
            content: get(err, 'graphQLErrors[0].message') || err.message,
            buttonMessage: <Trans {...messages.cancel} />,
          })
        })
    }
  }

  handleChangeAccount(prop, value) {
    if (prop === 'transferFromAccount') {
      const accounts = [...this.props.accounts, ...this.state.accountsWithdrawal]
      const account = find(accounts, ['id', value])
      const transferFromCurrency = account.currency
      const disabledTransfer = account.credit > 0 && account.hasOpenPositions
      this.setState((state) => ({
        [prop]: value,
        errorsFields: {...state.errorsFields, [prop]: !value},
        transferFromCurrency,
        disabledTransfer,
        withdrawalBlockedPopupOpen: disabledTransfer,
      }))
    } else {
      this.setState((state) => ({
        [prop]: value,
        errorsFields: {...state.errorsFields, [prop]: !value},
      }))
    }
  }

  findClient(btn) {
    const {affiliateClientId, affiliateAccountId, affiliateEmail} = this.state
    const form = {affiliateClientId, affiliateAccountId, affiliateEmail}
    const {
      transferFields: {affiliate: affiliateFields},
    } = config
    const errorsFieldsAffiliate = {}
    this.setState({clientCheckMsg: btn})
    for (const field of Object.keys(form)) {
      for (const affField of affiliateFields) {
        if (includes(field.toLowerCase(), affField))
          errorsFieldsAffiliate[field] = isEmpty(form[field])
      }
    }
    if (some(errorsFieldsAffiliate)) {
      this.setState({errorsFieldsAffiliate})
      return
    }
    this.props.client
      .query({
        query: FIND_CLIENT_QUERY,
        variables: {
          clientId: affiliateClientId,
          remoteId: affiliateAccountId,
          email: affiliateEmail,
          type: 'affiliate',
        },
      })
      .then((success) => {
        this.setState({
          affiliateError: '',
          affiliateSuccess: success.data.findClient,
          errorsFieldsAffiliate: {},
        })
      })
      .catch((err) =>
        this.setState({
          affiliateError: err.message.replace('GraphQL error: ', ''),
          affiliateSuccess: {},
        }),
      )
  }

  showAffiliateDetails() {
    const {classes} = this.props
    const {affiliateSuccess} = this.state
    const {
      transferFields: {affiliate: affiliateFields},
    } = config

    return (
      <React.Fragment>
        <Typography variant="caption">
          <Trans {...messages.accountDetails} />
        </Typography>
        <Typography variant="caption" className={classes.succText}>
          {affiliateSuccess['firstName']} {affiliateSuccess['lastName']}
        </Typography>
        {!includes(affiliateFields, 'email') && (
          <Typography variant="caption" className={classes.succText}>
            {affiliateSuccess['email']}
          </Typography>
        )}
      </React.Fragment>
    )
  }

  render() {
    const {
      accountsLoading,
      ibClientsLoading,
      clientsIbLoading,
      ibClients,
      clientsIb,
      classes,
      t,
      match: {params: urlParams},
      pathSpoa,
      pathSend,
      pathIb,
      relatedIbs,
      relatedIbsLoading,
    } = this.props
    if (accountsLoading || ibClientsLoading || clientsIbLoading || relatedIbsLoading)
      return <Loading />
    const {
      transferFrom,
      transferFromAccount,
      transferFromCurrency,
      transferTo,
      transferToAccount,
      transferAmount,
      errors,
      errorsFields,
      errorsFieldsAffiliate,
      submitButtonDisabled,
      affiliateClientId,
      affiliateAccountId,
      affiliateEmail,
      affiliateError,
      affiliateSuccess,
      clientCheckMsg,
      disabledTransfer,
    } = this.state
    const {transferFields} = config
    const affiliateFields = get(transferFields, 'affiliate', '')
    const accountsWithdrawal = !isEmpty(this.state.accountsWithdrawal)
      ? this.validAccountsWithdrawal(this.state.accountsWithdrawal)
      : this.validAccountsWithdrawal(this.props.accounts)
    const accountsDeposit = !isEmpty(this.state.accountsDeposit)
      ? this.validAccountsDeposit(this.state.accountsDeposit)
      : this.validAccountsDeposit(this.props.accounts)

    const selectedAccountId = Number(get(urlParams, 'accountId') || '')
    const forceSelectedAccount = transferFrom === '' && selectedAccountId
    const forceSelectedAccountCurrency =
      get(find(accountsWithdrawal, ['id', forceSelectedAccount]), 'currency') || 'EUR'

    const clientsAccounts = pathIb ? relatedIbs : !isEmpty(ibClients) ? ibClients : clientsIb
    const isFromCurrencyCryptoOrVirtual =
      get(currencies[transferFromCurrency || forceSelectedAccountCurrency], 'isCrypto', false) ||
      get(
        currencies[transferFromCurrency || forceSelectedAccountCurrency],
        'isVirtualCurrency',
        false,
      )

    const {themePreference} = this.context

    const fromAccount = find(
      accountsWithdrawal,
      (option) => option.id === (transferFromAccount || forceSelectedAccount),
    )

    const toAccount = find(
      accountsWithdrawal,
      (option) => option.id === (transferToAccount),
    )

    const hasPendingRequests =
      fromAccount?.pendingRequests?.length > 0 ||
      toAccount?.pendingRequests?.length > 0

    return (
      <div className={classes.root}>
        <Grid container>
          <WithdrawalBlockedPopup
            open={this.state.withdrawalBlockedPopupOpen}
            account={find(this.validAccountsWithdrawal(this.props.accounts), [
              'id',
              this.state.transferFromAccount,
            ])}
            onClose={() => this.setState({withdrawalBlockedPopupOpen: false})}
          />
          {hasPendingRequests && (
            <Grid item xs={12}>
              <NotificationBar status={'info'}>
                <Trans {...messages.hasPendingRequests} />
              </NotificationBar>
            </Grid>
          )}
          <Grid item xs={12} sm={5}>
            <Grid container spacing={2} className={classes.toGrid}>
              <Grid item xs={12}>
                <PageSubTitle>
                  <Trans {...messages.transferFromAccount} />
                </PageSubTitle>
              </Grid>
              <Grid item xs={12}>
                <AccountSearchSelect
                  accounts={accountsWithdrawal}
                  label={t(
                    messages.transferFromAccount.i18nKey,
                    messages.transferFromAccount.defaults,
                  )}
                  handleAccountChange={this.handleChangeAccount.bind(this)}
                  value={transferFromAccount || forceSelectedAccount}
                  name="transferFromAccount"
                  locale={this.context.locale}
                  errors={errorsFields}
                />
              </Grid>
            </Grid>
          </Grid>

          <Hidden only="xs">
            <Grid item sm={2} className={classes.transferIcon}>
              <img
                src={Images[`icon-arrow-right-${themePreference}.png`]}
                alt={t(messages.transferToAccount.i18nKey, messages.transferToAccount.defaults)}
              />
            </Grid>
          </Hidden>

          <Grid item xs={12} sm={5}>
            {clientsAccounts.length > 0 && (pathSpoa || pathIb) && (
              <Grid container spacing={2} className={classes.toGrid}>
                <Grid item xs={12}>
                  <PageSubTitle>
                    <Trans {...messages.transferTo} />
                  </PageSubTitle>
                </Grid>
                <Grid item xs={12}>
                  <AccountSearchSelect
                    clients={clientsAccounts}
                    label={t(messages.transferTo.i18nKey, messages.transferTo.defaults)}
                    handleAccountChange={this.handleClientToChange.bind(this)}
                    value={transferTo}
                    name="transferTo"
                    locale={this.context.locale}
                    errors={errorsFields}
                  />
                </Grid>
              </Grid>
            )}
            {!pathSend && !pathIb && (
              <Grid container spacing={2} className={classes.toGrid}>
                <Grid item xs={12}>
                  <PageSubTitle>
                    <Trans {...messages.transferToAccount} />
                  </PageSubTitle>
                </Grid>
                <Grid item xs={12}>
                  <AccountSearchSelect
                    accounts={accountsDeposit}
                    label={t(
                      messages.transferToAccount.i18nKey,
                      messages.transferToAccount.defaults,
                    )}
                    handleAccountChange={this.handleChangeAccount.bind(this)}
                    value={transferToAccount}
                    name="transferToAccount"
                    locale={this.context.locale}
                    errors={errorsFields}
                  />
                </Grid>
              </Grid>
            )}
            {pathSend && (
              <Grid container spacing={2} className={classes.toGrid}>
                <Grid item xs={12}>
                  <PageSubTitle>
                    <Trans {...messages.transferToAccount} />
                  </PageSubTitle>
                </Grid>
                {includes(affiliateFields, 'clientId') && (
                  <Grid item xs={10} sm={5}>
                    <TextField
                      required
                      id="affiliateClientId"
                      name="affiliateClientId"
                      label={t(
                        messages.affiliateClientId.i18nKey,
                        messages.affiliateClientId.defaults,
                      )}
                      fullWidth
                      autoComplete="affiliateClientId"
                      value={affiliateClientId}
                      error={errorsFieldsAffiliate.affiliateClientId}
                      onChange={(e) => {
                        this.handleChange('affiliateClientId', e.target.value)
                        this.setState({affiliateSuccess: {}})
                      }}
                    />
                  </Grid>
                )}
                {includes(affiliateFields, 'accountId') && (
                  <Grid item xs={10} sm={5}>
                    <TextField
                      required
                      id="affiliateAccountId"
                      name="affiliateAccountId"
                      label={t(
                        messages.affiliateAccountId.i18nKey,
                        messages.affiliateAccountId.defaults,
                      )}
                      fullWidth
                      autoComplete="affiliateAccountId"
                      value={affiliateAccountId}
                      error={errorsFieldsAffiliate.affiliateAccountId}
                      onChange={(e) => {
                        this.handleChange('affiliateAccountId', e.target.value)
                        this.setState({affiliateSuccess: {}})
                      }}
                    />
                  </Grid>
                )}
                {includes(affiliateFields, 'email') && (
                  <Grid item xs={10}>
                    <TextField
                      required
                      id="affiliateEmail"
                      name="affiliateEmail"
                      label={t(messages.email.i18nKey, messages.email.defaults)}
                      fullWidth
                      autoComplete="affiliateEmail"
                      value={affiliateEmail}
                      error={errorsFieldsAffiliate.affiliateEmail}
                      onChange={(e) => {
                        this.handleChange('affiliateEmail', e.target.value)
                        this.setState({affiliateSuccess: {}})
                      }}
                    />
                  </Grid>
                )}
                <Grid item xs={2} className={classes.searchDiv}>
                  <SearchOutlined
                    className={classNames(
                      classes.searchIcon,
                      affiliateError
                        ? classes.errText
                        : !isEmpty(affiliateSuccess)
                        ? classes.succText
                        : '',
                    )}
                    color="secondary"
                    onClick={() => this.findClient(false)}
                  />
                </Grid>
              </Grid>
            )}
          </Grid>
          {(affiliateError || !isEmpty(affiliateSuccess)) && (
            <Grid container spacing={1}>
              <Hidden xsDown>
                <Grid item xs={7}></Grid>
              </Hidden>
              <Grid item md={5} xs={12}>
                {affiliateError && (
                  <FormHelperText className={classes.error}>{affiliateError}</FormHelperText>
                )}
                {!isEmpty(affiliateSuccess) && this.showAffiliateDetails()}
              </Grid>
            </Grid>
          )}
        </Grid>

        <Grid container justifyContent="center">
          <Grid
            item
            sm={6}
            md={isFromCurrencyCryptoOrVirtual ? 7 : 4}
            className={classes.transferAmount}
          >
            <PageSubTitle>
              <Trans {...messages.selectAmount} />
            </PageSubTitle>
            <AmountInput
              jumbo
              onChange={(e) => this.handleChange('transferAmount', e.target.value)}
              value={transferAmount}
              id="transferAmount"
              name="transferAmount"
              currency={transferFromCurrency || forceSelectedAccountCurrency}
              locale={this.context.locale}
              TextFieldProps={{
                error: errorsFields.transferAmount,
                helperText:
                  errorsFields.transferAmount &&
                  t(messages.noZeroTransferAmount.i18nKey, messages.noZeroTransferAmount.defaults),
              }}
            />
            {errors.length > 0 && (
              <ul className={classes.errors}>
                {errors.map((error) => (
                  <li key={error}>{error}</li>
                ))}
              </ul>
            )}
            {fromAccount && isBitnukAccount(fromAccount) && (
              <Grid container item xs={12} spacing={3}>
                <Grid item xs={12} md={4}>
                  <Button
                    fullWidth
                    variant="contained"
                    className={classes.amountButton}
                    onClick={(e) =>
                      this.handleChange('transferAmount', floor(get(fromAccount, 'balance') / 4, 8))
                    }
                  >
                    <Typography variant="body2">25%</Typography>
                  </Button>
                </Grid>
                <Grid item xs={12} md={4}>
                  <Button
                    fullWidth
                    variant="contained"
                    className={classes.amountButton}
                    onClick={(e) =>
                      this.handleChange('transferAmount', floor(get(fromAccount, 'balance') / 2, 8))
                    }
                  >
                    <Typography variant="body2">50%</Typography>
                  </Button>
                </Grid>
                <Grid item xs={12} md={4}>
                  <Button
                    fullWidth
                    variant="contained"
                    className={classes.amountButton}
                    onClick={(e) =>
                      this.handleChange('transferAmount', get(fromAccount, 'balance'))
                    }
                  >
                    <Typography variant="body2">
                      <Trans {...messages.max} />
                    </Typography>
                  </Button>
                </Grid>
              </Grid>
            )}
            <LoadingButton
              disabled={submitButtonDisabled || disabledTransfer || hasPendingRequests}
              variant="contained"
              color="primary"
              size="large"
              onClick={() => this.isValid()}
              hideProgressBar={disabledTransfer || hasPendingRequests}
            >
              <Trans {...messages.continue} />
            </LoadingButton>
            {clientCheckMsg && !isEmpty(affiliateSuccess) && (
              <Grid item xs={12}>
                <FormHelperText classes={{root: classes.clientCheckMsg}}>
                  <Typography variant="caption" className={classes.textBlue}>
                    <Trans {...messages.clientCheckMsg} />
                  </Typography>
                </FormHelperText>
              </Grid>
            )}
          </Grid>
        </Grid>
      </div>
    )
  }
}

export default compose(
  withNamespaces(),
  withApollo,
  graphql(TRANSFER_FUNDS_MUTATION, {
    name: 'fundTransferMutation',
    options: {
      refetchQueries: [{query: PAYMENTS_ACCOUNTS_QUERY}],
    },
  }),
  graphql(IB_CLIENTS_QUERY, {
    props: (props) => {
      const ibClients = get(props.data, 'getIbClients', [])
      return {
        error: props.data?.error,
        ibClientsLoading: props.data?.loading,
        ibClients,
      }
    },
  }),
  graphql(RELATED_IB_QUERY, {
    props: (props) => {
      const relatedIbs = get(props.data, 'getRelatedIbs', [])
      return {
        error: props.data?.error,
        relatedIbsLoading: props.data?.loading,
        relatedIbs,
      }
    },
  }),
  graphql(SPOA_AUTHORIZATION_QUERY, {
    props: (props) => ({
      error: props.data?.error,
      clientsIbLoading: props.data?.loading,
      clientsIb: [get(props.data, 'viewer.spoaRemoteClient')],
    }),
  }),
  graphql(PAYMENTS_ACCOUNTS_QUERY, {
    props: (props) => {
      const accounts = reject(get(props.data, 'viewer.accounts'), 'isArchived')
      //@ts-ignore
      const pathSpoa = includes(props.ownProps.match.path, 'transferSpoa')
      //@ts-ignore
      const pathSend = includes(props.ownProps.match.path, 'transferSend')
      //@ts-ignore
      const pathIb = includes(props.ownProps.match.path, 'transferIb')
      return {
        error: props.data?.error,
        accountsLoading: props.data?.loading,
        accounts,
        pathSpoa,
        pathSend,
        pathIb,
      }
    },
  }),
  graphql(CLIENT_DATA_QUERY, {
    props: (props) => {
      const viewer = get(props.data, 'viewer')
      return {
        error: props.data?.error,
        viewerLoading: props.data?.loading,
        viewer,
      }
    },
  }),
  graphql(CREATE_INTERNAL_TRANSFER, {
    name: 'fundInternalTransferMutaion',
  }),
  withStyles(styles, {withTheme: true}),
)(Transfer)
